import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AuthProvider from "./context/auth";
import HotelRoomSearchProvider from "./context/HotelRoomSearch";
import ExpiringContextProvider from "./context/ExpiringBookings";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ExpiringContextProvider>
        <HotelRoomSearchProvider>
          <App />
        </HotelRoomSearchProvider>
      </ExpiringContextProvider>
    </AuthProvider>
  </React.StrictMode>
);
